import { graphql, useStaticQuery } from "gatsby";
import * as React from "react"; // tslint:disable-line
import { platformProviderValue, PromptTemplatesProvider as Provider } from "@shapeable/ui";

const QUERY = graphql`
  query PromptTemplatesQuery {
    platform {
      allPromptTemplates {
        id name label slug path __typename _entityTypeName
        hideInTemplateList
        summary { text }
        variablesPrompt { text }
        type { id name slug } 
        gptModel { id name slug dataSetId }
        languages { id name slug iso locale label }
        submitLabel
        orderNumber
        description { text }
        icon { id slug component }
        variables { 
          id name 
          slug 
          useVectorStore
          label 
          labelAnother
          help { text }
          options { text }
          defaultValue
          entityTypes { id internalName name slug }
          controlType {
            id name slug
          }
          labelContextual 
          labelAnotherContextual
          helpContextual { text }
          optionsContextual { text }
          defaultValueContextual
          entityTypesContextual { id internalName name slug }
          controlTypeContextual {
            id name slug
          }
        }
      }
    }
  }
`

export const PromptTemplatesProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(QUERY), 'allPromptTemplates' ) }>{children}</Provider>;
}